// #region Imports
import { useEffect, useState, useCallback } from 'react';
import comissoesApi from '../services/comissoesApi';
import { comissaoFromBackend, computeStats } from '../pages/Comissoes/comissao-utils';
// #endregion

export default function useComissoes() {
  // #region Estado
  const [comissoes, setComissoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // #endregion

  // #region Efeito carga inicial
  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true); setError(null);
      try {
        const raw = await comissoesApi.listAll();
        if (!active) return;
        setComissoes(raw.map(comissaoFromBackend));
      } catch (e) { if (active) setError(e); }
      finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, []);
  // #endregion

  // #region Listagem com filtros/paginação
  const listar = useCallback(({ q = '', funcionario_id = 'TODOS', status = 'TODOS', periodo = 'TODOS', page = 1, pageSize = 10 } = {}) => {
    const normalized = q.trim().toLowerCase();
    let filtered = comissoes;
    if (normalized) { filtered = filtered.filter(c => String(c.venda_id).includes(normalized)); }
    if (funcionario_id !== 'TODOS') filtered = filtered.filter(c => c.funcionario_id === Number(funcionario_id));
    if (status !== 'TODOS') filtered = filtered.filter(c => (status === 'PAGAS' ? c.pago : !c.pago));
    if (periodo !== 'TODOS') { filtered = filtered.filter(c => c.data_competencia.startsWith(periodo)); }
    const total = filtered.length;
    const start = (page - 1) * pageSize;
    const data = filtered.slice(start, start + pageSize);
    return { data, total, page, pageSize };
  }, [comissoes]);
  // #endregion

  // #region CRUD
  const obter = useCallback(id => comissoes.find(c => c.id === id) || null, [comissoes]);
  const criar = useCallback(async payload => { const dto = await comissoesApi.create(payload); const inst = comissaoFromBackend(dto); setComissoes(prev => [inst, ...prev]); return inst; }, []);
  const atualizar = useCallback(async (id, payload) => { const dto = await comissoesApi.update(id, payload); if (!dto) return null; const inst = comissaoFromBackend(dto); setComissoes(prev => prev.map(c => c.id === id ? inst : c)); return inst; }, []);
  const remover = useCallback(async id => { await comissoesApi.remove(id); setComissoes(prev => prev.filter(c => c.id !== id)); }, []);
  const alternarStatus = useCallback(async id => { const dto = await comissoesApi.toggleStatus(id); if (!dto) return null; const inst = comissaoFromBackend(dto); setComissoes(prev => prev.map(c => c.id === id ? inst : c)); return inst; }, []);
  // #endregion

  // #region Export
  return { comissoes, loading, error, listar, obter, criar, atualizar, remover, alternarStatus, computeStats };
  // #endregion
}
